import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useEffectOnce } from 'react-use';
import Statsig from 'statsig-js-local-eval';
import { getCountryConfigFromLocale } from '@/lib/i18n/getCountryConfigFromLocale';

export const useLogEvent = (
  name: string,
  eventOptions = {},
  options = { enabled: true }
) => {
  const router = useRouter();
  const { countryCode } = getCountryConfigFromLocale(router.locale!);

  useEffectOnce(() => {
    if (!options.enabled) return;

    Statsig.logEvent({ userID: Statsig.getStableID() }, name, '', {
      country: countryCode,
      ...eventOptions,
    });
  });
};

export const useLogEventEffect = (
  name: string,
  eventOptions = {},
  dependencies: readonly unknown[] = [],
  options = { enabled: true }
) => {
  const router = useRouter();
  const { countryCode } = getCountryConfigFromLocale(router.locale!);

  useEffect(
    () => {
      if (!options.enabled) {
        return;
      }

      Statsig.logEvent({ userID: Statsig.getStableID() }, name, '', {
        country: countryCode,
        ...eventOptions,
      });
    },
    // eslint-disable-next-line
    ...[dependencies]
  );
};
